/*
 *
 * CustomerCare Actions
 *
 * @version 1.0.0
 * @author Vittorio Scaperrotta
 * @since 27-Jan-2023
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index';

export const actionTypes = {
	DO_SET_ITEM_TO_SHOW_DETAIL: '@@CustomerCare/set_item_to_show_detail',
	DO_RESET_ERROR: '@@CustomerCare/reset_error',
	DO_RESET_DATA: '@@CustomerCare/reset_data',
	// @generator action:route:type
	...createRequestTypes('@@CustomerCare', 'FETCH_CUSTOMER_CARE_LIST'),
	...createRequestTypes('@@CustomerCare', 'FETCH_CUSTOMER_CARE_FIND'),
	...createRequestTypes('@@CustomerCare', 'FETCH_CUSTOMER_CARE_DETAIL'),
	...createRequestTypes('@@CustomerCare', 'UNLOCK_CUSTOMER_CARE_USER'),
	...createRequestTypes('@@CustomerCare', 'ENABLE_CUSTOMER_CARE_USER'),
	...createRequestTypes('@@CustomerCare', 'DELETE_CUSTOMER_CARE_USER'),
	...createRequestTypes('@@CustomerCare', 'DISABLE_CUSTOMER_CARE_USER'),

	...createRequestTypes('@@CustomerCare', 'FETCH_CUSTOMER_CARE_TRANSACTION_FIND'),
	...createRequestTypes('@@CustomerCare', 'FETCH_CUSTOMER_CARE_TRANSACTION_LIST'),
	// @generator action:route:type:request
};

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:route:request
/** @action request
 * * Insert a description
 * @name fetchCustomerCareList
 * @return {object} - The action object
 */
export const fetchCustomerCareList = new MakeRequest('CustomerCare', 'fetch_customer_care_list');
/** @action request
 * * Insert a description
 * @name fetchCustomerCareFind
 * @return {object} - The action object
 */
export const fetchCustomerCareFind = new MakeRequest('CustomerCare', 'fetch_customer_care_find');
/** @action request
 * * Insert a description
 * @name fetchCustomerCareDetail
 * @return {object} - The action object
 */
export const fetchCustomerCareDetail = new MakeRequest('CustomerCare', 'fetch_customer_care_detail');
/** @action request
 * * Insert a description
 * @name deleteCustomerCareUser
 * @return {object} - The action object
 */
export const deleteCustomerCareUser = new MakeRequest('CustomerCare', 'delete_customer_care_user');
/** @action request
 * * Insert a description
 * @name unlockCustomerCareUser
 * @return {object} - The action object
 */
export const unlockCustomerCareUser = new MakeRequest('CustomerCare', 'unlock_customer_care_user');
/** @action request
 * * Insert a description
 * @name enableCustomerCareUser
 * @return {object} - The action object
 */
export const enableCustomerCareUser = new MakeRequest('CustomerCare', 'enable_customer_care_user');
/** @action request
 * * Insert a description
 * @name disableCustomerCareUser
 * @return {object} - The action object
 */
export const disableCustomerCareUser = new MakeRequest('CustomerCare', 'disable_customer_care_user');





/** @action request
 * * Insert a description
 * @name fetchCustomerCareTransactionFind
 * @return {object} - The action object
 */
export const fetchCustomerCareTransactionFind = new MakeRequest('CustomerCare', 'fetch_customer_care_transaction_find');
/** @action request
 * * Insert a description
 * @name fetchCustomerCareTransactionList
 * @return {object} - The action object
 */
export const fetchCustomerCareTransactionList = new MakeRequest('CustomerCare', 'fetch_customer_care_transaction_list');




// @generator action:route
/** @action
 * * Insert a description
 * @name ResetData
 * @return {object} - The payload object
 */
export const doResetData = (payload) => createAction(actionTypes.DO_RESET_DATA, { payload });
/** @action
 * * Insert a description
 * @name ResetError
 * @return {object} - The payload object
 */
export const doResetError = (payload) => createAction(actionTypes.DO_RESET_ERROR, { payload });
/** @action
 * * Insert a description
 * @name SetItemToShowDetail
 * @return {object} - The payload object
 */
export const doSetItemToShowDetail = (payload) => createAction(actionTypes.DO_SET_ITEM_TO_SHOW_DETAIL, { payload });
